export default class fvRenderTexture {
    constructor(renderConfig,system,callback) {
        this.lastSrc="";
        this.system=system;
        this.renderConfig=renderConfig;
        var projectName = system.$.projectName;
        this.arrangeStyle = renderConfig.arrangeStyle;
        system.$.getImgCache("src/" + projectName + "/img/" + renderConfig.src).then((img)=>{
            this.img = img;
            callback(this);
        },((img) =>{
            this.img = img;
            callback(this);
        }));
    }

    rend(canvas, rect, obj) {
        if(this.system.$.indexDB[0].isSvg==false){
            if(obj==undefined){
                console.warn("渲染对象不能为空");
                return;
            }
            switch(this.arrangeStyle){
                case 0:
                case 1:
                case 2:
                case 3:
                    this.rend1(canvas, rect, obj);
                    break;
                case 4:
                    this.rend2(canvas, rect, obj);
                    break;
                default:
                    this.rend3(canvas, rect, obj);
                    break;
            }
        }else{
            switch(this.arrangeStyle){
                case 0:
                case 1:
                case 2:
                case 3:
                    this.rend4(canvas,rect,obj);
                    break;
                case 4:
                    this.rend5(canvas, rect, obj);
                    break;
                default:
                    this.rend6(canvas, rect, obj);
                    break;
            }
        }
        
    }
    
    rend1(canvas, rect, obj) {
        var config = this.renderConfig;
        canvas.globalAlpha = config.transparent / 255;
        if (this.img) {
           let widthLength = Math.ceil(rect.width / this.img.naturalWidth);
           let heightLength = Math.ceil(rect.height / this.img.naturalHeight);
            for (var i = 0; i < heightLength; i++) {
                canvas.drawImage(this.img, rect.left, rect.top + this.img.naturalHeight * i);
                for (var j = 0; j < widthLength; j++) {
                    canvas.drawImage(this.img, rect.left + this.img.naturalWidth * j, rect.top + this.img.naturalHeight * i);
                }
            }
        }
        canvas.lineWidth = rect.borderWidth;
        canvas.stroke();
    }

    rend2(canvas, rect, obj) {
        var config = this.renderConfig;
        canvas.globalAlpha = config.transparent / 255;
        if(this.img){
            var rectLeft = 0;
            var rectTop = 0;
            if(rect.width > this.img.naturalWidth){
                rectLeft = rect.width/2 - this.img.naturalWidth/2 + rect.left;
            }else{
                rectLeft = rect.left;
            }
            if(rect.height > this.img.naturalHeight){
                rectTop = rect.height/2 - this.img.naturalHeight/2 + rect.top;
            }else{
                rectTop = rect.top;
            }
            canvas.drawImage(this.img,0,0,rect.width,this.img.naturalHeight,rectLeft,rectTop,rect.width,this.img.naturalHeight);
        }
        canvas.lineWidth = rect.borderWidth;
        canvas.stroke();
    }

    rend3(canvas, rect, obj) {
        var config = this.renderConfig;
        canvas.globalAlpha = config.transparent / 255;
        if (this.img) {
            canvas.drawImage(this.img, rect.left, rect.top, rect.width, rect.height);
        }
        canvas.lineWidth = rect.borderWidth;
        canvas.stroke();

    }
    rend4(svg,rect, idll) {
        var config = this.renderConfig;
        rect.setAttribute("fill-opacity", config.transparent / 255);
        if (this.img) {
           let widthLength = Math.ceil(parseFloat(rect.style.width) / this.img.naturalWidth);
           let heightLength = Math.ceil(parseFloat(rect.style.height) / this.img.naturalHeight);
           var imgStr="";
            for (var i = 0; i < heightLength; i++) {
                imgStr+=`<image xlink:href="${this.img.src}" x="0" y="0"/>`;
                for (var j = 0; j < widthLength; j++) {
                    imgStr+=`<image xlink:href="${this.img.src}" x="${this.img.naturalWidth}" y="0"/>`;
                }
            }
            document.getElementById(idll).innerHTML+=imgStr;
        }
        
    }

    rend5(svg,rect, idll) {
        var config = this.renderConfig;
        rect.setAttribute("fill-opacity", config.transparent / 255);
        if(this.img){
            var imgStr=`<image xlink:href="${this.img.src}"  width="${this.img.naturalWidth}" height="${this.img.naturalHeight}" />`;
            document.getElementById(idll).innerHTML=imgStr;
        }
    }

    rend6(svg,rect, idll) {
         var config = this.renderConfig;
        rect.setAttribute("fill-opacity", config.transparent / 255);
        if (this.img) {
           let widthLength = Math.ceil(parseFloat(rect.style.width) / this.img.naturalWidth);
           let heightLength = Math.ceil(parseFloat(rect.style.height) / this.img.naturalHeight);
           var imgStr;
           imgStr=`<image xlink:href="${this.img.src}" x="${widthLength}" preserveAspectRatio="none meet" width="${parseFloat(rect.style.width)}" height="${parseFloat(rect.style.height)}" y="${heightLength}"/>`;
            document.getElementById(idll).innerHTML=imgStr;
            document.getElementById(idll).setAttribute("x",0);
            document.getElementById(idll).setAttribute("y",0);
        }

    }
}


// WEBPACK FOOTER //
// ./src/js/render/fvRenderTexture.js